import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import PrimaryButton from "shared/components/PrimaryButton";
import { BORDER, COLOR_BLACK_5, COLOR_GREY_4 } from "shared/theme/colors";
import { flex } from "shared/theme/mixins";

export const StyledButton = styled(PrimaryButton)`
  &.MuiButton-root {
    font-size: 1rem;
    font-weight: 700;

    &.contained {
      border-radius: 0.5rem;
    }
  }
`;

export const StyledRefreshButton = styled(Box)`
  ${flex({ jc: "center", ai: "center" })};
  border-right: ${BORDER(1, COLOR_GREY_4)};
  width: 2rem;
  height: 2rem;
  border-radius: 0.5rem;
  background-color: ${COLOR_BLACK_5};
  cursor: pointer;
`;
